<app-section
  titleSection="Caractéristiques du bien"
  [isActivated]="characteristics.isEnabled"
  (enabled)="onEnabled($event)"
  (cancled)="onCancled()"
>
  <div read-mode class="px-3">
    <app-caracteristiques-read-mode
      [characteristics]="characteristics"
      [propertyType]="propertyType"
    >
    </app-caracteristiques-read-mode>
  </div>

  <div edit-mode>
    <app-caracteristiques-edit-mode
      [characteristics]="characteristics"
      [propertyType]="propertyType"
      (characteristicsChanged)="onCharacteristicsChanged($event)"
    >
    </app-caracteristiques-edit-mode>
  </div>

  <div save-button>
    <p-button
      id="btn-valider-section"
      label="Valider"
      level="primary"
      title="Valider"
      [loading]="isLoading"
      [disabled]="isLoading"
      (click)="onSaveSection()"
    ></p-button>
  </div>
</app-section>
